const initialState = {
    captureIntentEnabled: false,
    captureIntentSubmitted: false
};

export const urls = {
    getIntentEnabled: '/api/intent/eligibility',
    postIntentSubmit: '/api/intent'
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'RECEIVE_ENABLE_TRUE':
            return {
                ...state,
                captureIntentEnabled: action.data.enabled
            };
        case 'REQUEST_SUBMIT_TRUE':
            return {
                ...state,
                captureIntentSubmitted: true
            };
        default:
            return state;
    }
};
